import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dps-list',
  templateUrl: './dps-list.component.html',
  styleUrls: ['./dps-list.component.css']
})
export class DpsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
